import React from 'react'
import { FaRepeat } from "react-icons/fa6";
export default function Phatlai() {
  return <FaRepeat />
}
